import React, {
  Dispatch,
  ForwardRefRenderFunction,
  SetStateAction,
} from "react"
import clsx from "clsx"

import { ViewerBackgroundType } from "types"
import { ParagraphData } from "src/models/viewer/paragraph/ParagraphData"
import styles from "./index.module.scss"
import Paragraph from "../Paragraph"
import { getTieupImgSrc } from "../../common/TieupImg/getTieupImgSrc"

export type PageProps = {
  backgroundType?: ViewerBackgroundType
  data: Array<string | ParagraphData>
  rightShift?: number
  image?: string
  pageElement?: Dispatch<SetStateAction<HTMLDivElement | null>>
  width?: number
}

const Page: ForwardRefRenderFunction<HTMLDivElement, PageProps> = (
  {
    backgroundType = ViewerBackgroundType.Cream,
    data,
    pageElement,
    width,
    rightShift = 0,
    image,
  },
  ref,
) => {
  return (
    <div
      className={clsx({
        [styles.page]: true, // デフォルトは Cream
        [styles.white]: backgroundType === ViewerBackgroundType.White,
        [styles.black]: backgroundType === ViewerBackgroundType.Black,
      })}
      ref={pageElement}
      style={{ visibility: pageElement ? "hidden" : "visible" }}
    >
      <div
        className={styles.pageInner}
        style={{
          width: width,
          backgroundImage: image ? `url(${getTieupImgSrc(image)})` : "none",
        }}
      >
        <div
          className={styles.pageContent}
          ref={ref}
          style={{ transform: `translateX(${rightShift}px)` }}
        >
          {/* 挿絵ページ以外の背景画像の透明度を 0.2 にする */}
          <div
            className={styles.overlay}
            style={{ transform: `translateX(${-1 * rightShift}px)` }}
          />
          {data.map((p, idx) => (
            <Paragraph data={p} key={idx} />
          ))}
        </div>
      </div>
    </div>
  )
}

const ForwardPage = React.forwardRef(Page)

export default ForwardPage
